import { withDefaults } from '@warp-drive/legacy/model/migration-support';

// Abstract polymorphic resource for the `digital-asset` role. Concrete asset
// types (public-asset, tas-asset, pslf-asset, raw-file-digital-asset,
// file-history, observable-document, ...) gain these fields via
// `traits: ['digital-asset']`; this resource exists so the `digital-asset`
// target type resolves through the schema service when referenced
// polymorphically (`asset-summary.digitalAsset`, `attachment.digitalAsset` —
// both belongsTo the abstract type with `polymorphic: true`). Without it those
// references recurse into the legacy ModelSchemaProvider / ShimModelClass
// (RangeError: Maximum call stack size exceeded). Fields mirror the
// `digital-asset` trait.
const DigitalAssetSchema = withDefaults({
  type: 'digital-asset',
  fields: [
    { kind: 'attribute', name: 'bucket' },
    { kind: 'attribute', name: 'contentType' },
    { kind: 'attribute', name: 'downloadUrls' },
    { kind: 'attribute', name: 'filename' },
    { kind: 'attribute', name: 'fullPath' },
    { kind: 'attribute', name: 'raw' },
    { kind: 'attribute', name: 'name' },
    { kind: 'attribute', name: 'path' },
    { kind: 'attribute', name: 'size' },
    { kind: 'attribute', name: 'slug' },
    { kind: 'attribute', name: 'tags' },
    { kind: 'attribute', name: 'uuid' },
    { kind: 'attribute', name: 'signedUrl' },
    { kind: 'attribute', name: 'classification' },
    { kind: 'attribute', name: 'description' },
    { kind: 'attribute', name: 'createdAt' },
    { kind: 'attribute', name: 'updatedAt' },
    { kind: 'attribute', name: 'attachmentDeletedAt' },
    {
      kind: 'hasMany',
      name: 'attachments',
      type: 'attachment',
      options: {
        async: false,
        inverse: null,
      },
    },
    {
      kind: 'belongsTo',
      name: 'assetSummary',
      type: 'asset-summary',
      options: {
        async: false,
        inverse: 'digitalAsset',
        polymorphic: true,
        as: 'digital-asset',
      },
    },
  ],
});

export default DigitalAssetSchema;
